import { getStoredToken } from '../features/admin/auth/authStorage';
import { API_BASE } from './config';

/**
 * Login API call
 * @param {{ mobile_no: string, password: string }} credentials
 * @returns {Promise<{ token: string, user: object }>}
 */
export async function loginApi({ mobile_no, password }) {
  const response = await fetch(`${API_BASE}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ mobile_no, password }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Login failed.');
  }

  return data;
}

/**
 * Change password for the logged-in user.
 * @param {{ current_password: string, new_password: string }} payload
 */
export async function changePasswordApi({ current_password, new_password }) {
  const token = getStoredToken();
  const response = await fetch(`${API_BASE}/auth/change-password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ current_password, new_password }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Password change failed.");
  }

  return data;
}
